// ============================================================================
// SmsEnrollFlow
// Owner: Claude 3 (Frontend & UX).
// Purpose: SMS OTP enroll. NOTE: SMS is the weakest factor and is forbidden
//          for QA tier — see TwoFactorEnrollment for the SEC-021 gate.
// URS rows: AUTH-004.
// ============================================================================
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEnrollSms, useVerifySms } from '../../api/twoFactorHooks';

export function SmsEnrollFlow({ onDone }: { onDone: () => void }) {
  const { t } = useTranslation();
  const enroll = useEnrollSms();
  const verify = useVerifySms();
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [challengeId, setChallengeId] = useState<string | null>(null);

  return (
    <div>
      <h2>{t('twofa.sms.card_title')}</h2>
      <p role="note">{t('twofa.sms.weak_factor_warning')}</p>
      {!challengeId ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            enroll.mutate({ phoneNumber: phone }, {
              onSuccess: (r) => setChallengeId(r.challengeId),
            });
          }}
        >
          <label htmlFor="sms-phone">{t('twofa.sms.phone_label')}</label>
          <input
            id="sms-phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <button type="submit" disabled={enroll.isPending}>
            {t('twofa.sms.send_code')}
          </button>
        </form>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            verify.mutate({ challengeId, code }, { onSuccess: () => onDone() });
          }}
        >
          <label htmlFor="sms-code">{t('twofa.sms.verify_prompt')}</label>
          <input
            id="sms-code"
            inputMode="numeric"
            pattern="\d{6}"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
          <button type="submit" disabled={verify.isPending}>
            {t('twofa.common.set_up')}
          </button>
        </form>
      )}
      {(enroll.isError || verify.isError) && (
        <p role="alert">{String(enroll.error ?? verify.error)}</p>
      )}
    </div>
  );
}
